module.exports = __webpack_public_path__ + "c_static/img/5分享淘口令.4b0cbce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/5分享淘口令.jpg
// module id = Q4qi
// module chunks = 33